import {
  EVENT_SET_EVENT_BEGIN,
  EVENT_SET_EVENT_SUCCESS,
  EVENT_SET_EVENT_FAILURE,
  EVENT_SET_EVENT_DISMISS_ERROR,
} from './constants';

//HELPER
import { API } from '../../../helper/api';
import { putArray } from '../../../helper/array';
import ReduxHelper from '../../../helper/redux';
import { BOOKING_ADD_BOOKING_SUCCESS, BOOKING_DELETE_BOOKING_SUCCESS } from '../../booking/redux/constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function setEvent(id, _args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument

    dispatch({
      type: EVENT_SET_EVENT_BEGIN,
    });

    API.msg({
      loading: (_args.status === 0 ? "sauvegarde" : "publication") + " en cours...",
      success: _args.status === 0 ? "sauvegarder" : "publier",
      error: "Oups, une erreur s'est produite"
    });

    return API.patch('event/'+id, _args).then(
        (res) => {
          dispatch({
            type: EVENT_SET_EVENT_SUCCESS,
            data: res.data,
          });

          return res;
        })
      // Use rejectHandler as the second argument so that render errors won't be caught.
      .catch(
        (err) => {
          dispatch({
            type: EVENT_SET_EVENT_FAILURE,
            data: { error: err },
          });

          return Promise.reject(err);
        },
      );
    }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSetEventError() {
  return {
    type: EVENT_SET_EVENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENT_SET_EVENT_BEGIN:
      // Just after a request is sent
      return ReduxHelper.begin(state, setEvent.name)

    case EVENT_SET_EVENT_SUCCESS:
      // The request is success
      return {
        ...ReduxHelper.success(state, setEvent.name),
        list: putArray(state.list, action.data),
        //current_item: action.data
      };

    case BOOKING_ADD_BOOKING_SUCCESS:
      return {
        ...state,
        list: state.list.map((e) => e.id === action.data.event_id ? { ...e, subscribedNumber: e.subscribedNumber + 1} : e),
        current_item: {
          ...state.current_item,
          booked: true,
          event: {
            ...state.current_item.event,
            subscribedNumber: state.current_item.event.subscribedNumber + 1
          }
        }
      }

    case BOOKING_DELETE_BOOKING_SUCCESS:
      return {
        ...state,
        list: state.list.map((e) => e.id === action.data.event_id ? { ...e, subscribedNumber: e.subscribedNumber - 1} : e),
        current_item: {
          ...state.current_item,
          booked: false,
          event: {
            ...state.current_item.event,
            subscribedNumber: state.current_item.event.subscribedNumber - 1
          }
        }
      }

    case EVENT_SET_EVENT_FAILURE:
      // The request is failed
      return ReduxHelper.error(state, setEvent.name, action.data.error)

    case EVENT_SET_EVENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return ReduxHelper.dismiss(state, setEvent.name)

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/event/redux/setEvent.js